import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {PulseLoader} from 'react-spinners';
import * as actions from '../../actions';
import {URL} from '../../config/Config';
/**
 * Import components
 */
import ActiveWidthLength from './StepOne/ActiveWidthLength';
import Calculation from './StepOne/Calculation';
import {Maybe, logging} from '../../utils/logging';

import {setRequiredDataFormat, setSwitchValue, deleteUnnecessaryFields, initialClean} from '../../utils/prepareData';
import {mmCodes, dwdFieldsToDelete, fieldsToDelete, metricConversion, convertStringToNumber, parseNumberToString} from '../../utils/helpers';
import {getActiveLanguage} from "react-localize-redux/lib/index";

/**
 * class StepOne
 */
class StepOne extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
        }
    }

    // TODO - check fields for the DWDF
    componentDidMount() {
        // set Z switch field
        let newState = setSwitchValue(this.props.dwdf, ['Z23', 'Z45', 'Z67', 'Z81']);
        // set data format (code:value) required for POST
        newState = setRequiredDataFormat(newState);
        // transform from cm to mm
        mmCodes.forEach((code) => {
            Maybe.of(newState[code])
            .map((value) => {
                const currentValue = convertStringToNumber(value);
                newState[code] = metricConversion(currentValue, 'cm', 'mm').toString();
            })
        });
        // clean data
        newState = initialClean(newState, ['-']);
        // delete local data
        newState = deleteUnnecessaryFields(newState, fieldsToDelete);

        // change GT to string
        Maybe.of(parseNumberToString(newState.GT)._value)
        .map((value) => {
            newState.GT = value;
        })

        // change OT to string
        Maybe.of(parseNumberToString(newState.OV)._value)
        .map((value) => {
            newState.OV = value;
        })

        // set data object for fetch
        const data = {
            BaseArticle: this.props.articleID,
            Evaluate:    'true',
            Features:    newState,
        }
        // fetch data
        this.props.fetchData(`${URL}data?_locale=${this.props.currentLanguage}`, 'POST', data, 'dwdf')
            .then(([currentState, article, articleID]) => {
                // update model
                this.props.setBreadCrumbs(currentState.breadcrumbs[1], currentState.dwdf.MODEL);
                // fetch image
                return this.props.fetchImage(currentState[article], article, articleID);
            })
            .then((result) => {
                // set loading state to false
                return this.props.setLoadingState(false);
            })
            .then((result) => {
                return this.props.isFormValid();
            })
            .catch((err) => {
                console.error(err);
            });
    }

    initialLoad(loading) {
        if (loading) {
            return (
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <div className='align-center sweet-loading'>
                        <PulseLoader
                            color={'#003B71'}
                            loading={this.props.loading}
                        />
                        </div>
                        </div>
            )
        }
        else {
            return (
                this.props.dwdf.VAR_ABM.CurrentValue === '1' ? <ActiveWidthLength /> : <Calculation />
            );
        }
    }

    /**
    * render method
    * @returns {XML}
    */
    render() {
        return (
            <div className='step-content'>
                {this.initialLoad(this.props.loading)}
            </div>
        );
    }

}

StepOne.propTypes = {
    lastStep:        PropTypes.number,
    dwdf:            PropTypes.object,
    //changedwdf:      PropTypes.func.isRequired,
    fetchData:       PropTypes.func.isRequired,
    loading:         PropTypes.bool,
    setLoadingState: PropTypes.func.isRequired,
    articleID:       PropTypes.string.isRequired,
    fetchImage:      PropTypes.func.isRequired,
    isFormValid:     PropTypes.func.isRequired,

}

function mapStateToProps({dwdf, loading, image, locale}) {
    return {
        dwdf,
        loading,
        image,
        currentLanguage: getActiveLanguage(locale).code,
    }
}

export default connect(mapStateToProps, actions)(StepOne);






// WEBPACK FOOTER //
// ./src/components/dwdf-steps/StepOne.js